/**
 * 微信auth地址生成器
 */
import conf from '../../conf/wx.conf'
import { getUrlParamsByObject } from '../../utils/tools'

// 认证链接生成器
class AuthUrlGenerator {
  constructor () {
    this.params = Object.assign({}, conf.WX_AUTH_BASE_PARAMS)
  }

  /**
   * 设置链接参数
   * @param { Object } options
   */
  setOptions (options = {}) {
    this.params = Object.assign({}, conf.WX_AUTH_BASE_PARAMS, options)
    return this
  }

  /**
   * 设置链接state值
   * @param { Object } value
   */
  setState (value) {
    let stateString = ''
    if (value instanceof String) {
      stateString = value
    } else if (value instanceof Object) {
      stateString = getUrlParamsByObject(value, conf.STATE_JOIN_CHAR)
    }
    stateString && (this.params.state = stateString)
    return this
  }

  /**
   * 获取认证链接
   */
  getAuthUrl () {
    let url = ''
    for (const key of conf.WX_AUTH_PARAMS_ORDER) {
      const value = this.params[key]
      if (value) {
        url = !url ? `${conf.WX_AUTH_BASE_URL}?${key}=${value}` : `${url}&${key}=${value}`
      }
    }
    return `${url}${conf.WX_AUTH_URL_SUFFIX}`
  }
}

export default AuthUrlGenerator
